import React from 'react';

interface SessionData {
    session: string;
    tags: Record<string, (string | boolean)[]>;
}

type MultiLevelRendererProps = {
    template: string;
    componentMap: Record<string, React.ReactElement>;
};
let sessionMenu : Map<string, string | null> = new Map();
function parseTemplate(template: string): SessionData[] {
    const sessions: SessionData[] = [];

    const regex = /\{\$(\w+)\}(?:\.\{(\w+)\}(?:\.\{([\s\S]*?)\})?)?(?=\r?\n|$)/g;
    let match;
    let currentSession: SessionData | null = null;

    while ((match = regex.exec(template)) !== null) {
        const sessionName = match[1];
        const tag = match[2];
        const value = match[3];

        if (!currentSession || currentSession.session !== sessionName) {
            currentSession = {
                session: sessionName,
                tags: {},
            };
            sessions.push(currentSession);
        }

        if (tag) {
            if (!currentSession.tags[tag]) {
                currentSession.tags[tag] = [];
            }
            currentSession.tags[tag].push(value !== undefined ? value : true);
        }

    }
    const added = new Set<string>();
    sessions.forEach(({ session, tags }) => {
        if (session === 'MENU') return;
        if (added.has(session)) return;

        if (typeof tags?.TITLE?.[0] != 'undefined' && typeof tags?.TITLE?.[0] == 'string') {
            const title = tags?.TITLE?.[0];
            sessionMenu.set(session, title);
        } else {
            sessionMenu.set(session, null);
        }
        added.add(session);
    })
    return sessions;
}

const MultiLevelDynamicRenderer: React.FC<MultiLevelRendererProps> = ({ template, componentMap }) => {
    const sessionList = parseTemplate(template);

    return (
        <>
            {sessionList.map((sessionData, index) => {
                const sessionElement = componentMap[sessionData.session];
                if (!sessionElement) return null;

                return React.cloneElement(sessionElement, {
                    key: `${sessionData.session}-${index}`,
                    content: sessionData.session === "MENU" ? sessionMenu : sessionData.tags,
                });
            })}
        </>
    );
};

export default MultiLevelDynamicRenderer;
